import {
    SimulationResultData,
    Response,
} from 'routes/HumanResourcesModule/business/types';

export type ResultTotalData = {
    hrSimulationData: Response<SimulationResultData>;
    previousYearRealizedTotalAmount: number;
    currentYearRealizedTotalAmountUntilStartDate: number;
    currentYearRealizedTotalAmountUntilLastMonth: number;
    currentYearSimulatedTotalAmountFromStartDate: number;
    currentYearSimulatedTotalAmountFromLastMonth: number;
    nextYearRealizedTotalAmount: number;
    nextYearSimulatedTotalAmountFromLastMonth: number;
    nextYearSimulatedTotalAmount: number;
};
export type TotalResultAmounts = {
    previousYearRealizedTotalAmount: number;
    currentYearRealizedTotalAmountUntilStartDate: number;
    currentYearRealizedTotalAmountUntilLastMonth: number;
    currentYearSimulatedTotalAmountFromStartDate: number;
    currentYearSimulatedTotalAmountFromLastMonth: number;
    nextYearRealizedTotalAmount: number;
    nextYearSimulatedTotalAmountFromLastMonth: number;
    nextYearSimulatedTotalAmount: number;
};
export enum variationType {
    PAST_PREVISIONNAL = 'pastPrevisionnal',
    PAST_LAST_YEAR = 'pastLastYear',
    PREVISIONNAL = 'previsionnal',
    INITIAL = 'initial',
}
